export default __webpack_public_path__ + "static/media/NoContactsImage.2579b8b5.svg";